module.exports = __webpack_public_path__ + "GothamRoundedMedium.dffb2b80813d195d26fa.ttf";


//////////////////
// WEBPACK FOOTER
// D:/TELEMED-FINAL/telemed/src/library/fonts/GothamRoundedMedium.ttf
// module id = ../../../../../src/library/fonts/GothamRoundedMedium.ttf
// module chunks = styles